export default __webpack_public_path__ + "static/graphik-web-regular-74b0a7ab6d091d43d1f0bb6ca66175bd.woff";